import Vue from 'vue'
import Vuex from 'vuex'

import units from './modules/units'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    units
  },
  strict: debug
})
